import { render, staticRenderFns } from "./PT403PassWordChangeParts.vue?vue&type=template&id=058ad788&"
import script from "./PT403PassWordChangeParts.vue?vue&type=script&lang=js&"
export * from "./PT403PassWordChangeParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports